exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin_bottom_12[data-v-01411e5f]{\n  margin-bottom:12px;\n}\n.margin_bottom_8[data-v-01411e5f]{\n  margin-bottom:8px;\n}\n.red[data-v-01411e5f]{\n  margin-bottom:10px;\n  color:#ff0000;\n  font-size:12px;\n}\n", ""]);

// exports
